export const environment = {
  production: true,
  BASE_URL_BACKEND  : '/api/v1',
  envName: 'prod'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts